import { useMemo } from 'react'
import {
  citizenshipsKz,
  citizenshipsRf,
  allFiscalCountriesKz,
  allFiscalCountriesRf,
  allFiscalCitizenshipCountries,
  addressCountries,
  addressFiscalCountriesKz,
  addressFiscalCountriesRf,
  IpCitizenshipCountries,
} from '../content/countries'
import { COUNTRY } from '../server-parameters'
import { Lang } from '../types/common-types'

const PRIORITY_CODES = ['398', '643', '112', '051']
const TOP_CODE = COUNTRY === 'kz' ? '398' : '643'

function sortCountriesList(list: any[], lang: Lang, topCode: string) {
  return [...list]
    .sort((a, b) => a.label[lang].toLowerCase().localeCompare(b.label[lang].toLowerCase()))
    .sort((a, b) => PRIORITY_CODES.includes(a.value.toString()) ? -1 : PRIORITY_CODES.includes(b.value.toString()) ? 1 : 0)
    .sort((a, b) => a.value.toString() === topCode ? -1 : b.value.toString() === topCode ? 1 : 0)
}

interface UseCountryListsArgs {
  settingsCitizenship: { countryCode: string; isActive?: boolean }[]
  lang: Lang
}

interface UseCountryListsResult {
  citizenshipsList: any[]
  allFiscalSort: any[]
  allCitizenshipsFiscalSort: any[]
  allCitizenshipsAddressSort: any[]
  allCitizenshipsFiscalAddressSort: any[]
}

/** Builds all sorted country/citizenship lists used across form steps. */
export function useCountryLists({ settingsCitizenship, lang }: UseCountryListsArgs): UseCountryListsResult {
  const citizenshipsList = useMemo(() => {
    const base = COUNTRY === 'kz' ? citizenshipsKz : citizenshipsRf
    return settingsCitizenship
      .filter(e => base.find(f => f.value === e.countryCode))
      .map(m => ({
        value:    m.countryCode,
        label:    base.find(f => f.value === m.countryCode)?.label,
        disabled: !m.isActive,
      }))
      .sort((a: any, b: any) => a.label?.[lang]?.toLowerCase().localeCompare(b.label?.[lang]?.toLowerCase()))
      .sort((a: any) => PRIORITY_CODES.includes(a.value) ? -1 : 1)
      .sort((a: any, b: any) => a.value === TOP_CODE ? -1 : b.value === TOP_CODE ? 1 : 0)
  }, [settingsCitizenship, lang])

  const allFiscalSort = useMemo(
    () => COUNTRY === 'kz' ? sortCountriesList(allFiscalCountriesKz, lang, '398') : allFiscalCountriesRf,
    [lang]
  )

  const allCitizenshipsFiscalSort = useMemo(
    () => COUNTRY === 'kz' ? sortCountriesList(allFiscalCitizenshipCountries, lang, '398') : IpCitizenshipCountries,
    [lang]
  )

  const allCitizenshipsAddressSort = useMemo(
    () => sortCountriesList(addressCountries, lang, TOP_CODE),
    [lang]
  )

  const allCitizenshipsFiscalAddressSort = useMemo(
    () => COUNTRY === 'kz' ? sortCountriesList(addressFiscalCountriesKz, lang, '398') : addressFiscalCountriesRf,
    [lang]
  )

  return {
    citizenshipsList,
    allFiscalSort,
    allCitizenshipsFiscalSort,
    allCitizenshipsAddressSort,
    allCitizenshipsFiscalAddressSort,
  }
}
